import { saveVersion } from "@/core/services/version/version.service";

export const updatePWA = {
  data() {
    return {
      refreshing: false, // state of refreshing page
      registration: null, // service worker registration new data
      updateExists: false, // new content flag
    };
  },

  created() {
    // Listen for our custom event from the service worker registration
    document.addEventListener("serviceWorkerUpdated", this.updateAvailable, {
      once: true,
    });

    // Prevent multiple refreshes
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (this.refreshing) return;
      this.refreshing = true;
      // save current version in local storage before update
      const version = process.env.VUE_APP_VERSION;
      saveVersion(version);
      // Here the actual reload of the page occurs
      window.location.reload(); // !HARD REFRESH
    });
  },

  methods: {
    // Store the service worker registration so we can send it a message
    // We use `updateExists` flag to control whatever alert, toast, dialog, etc we want to use
    // To alert the user there is an update they need to refresh for
    updateAvailable(event) {
      this.registration = event.detail;
      this.updateExists = true;
    },

    // Called when the user accepts the update
    refreshApp() {
      this.updateExists = false;
      // Make sure we only send a 'skip waiting' message if the service worker is waiting
      if (!this.registration || !this.registration.waiting) return;
      // send message to service worker to skip the waiting and activate the new SW
      this.registration.waiting.postMessage({ type: "SKIP_WAITING" });
    },
  },
};

export default updatePWA;
